import { fireTag } from '@nuxt-common/util/app/utils/tagManager';

function fire(type: 'view' | 'link', payload, fireImmediately?: boolean) {
  if (!fireImmediately) {
    setTimeout(() => {
      fireTag(type, payload);
    }, 0);
  } else {
    fireTag(type, payload);
  }
}

/**
 * fireImmediately should be true for hrefs otherwise the tag will not fire before the page redirect occurs
 */
export function fireLinkTag(payload, fireImmediately = false) {
  fire('link', payload, fireImmediately);
}

export function fireViewTag(payload) {
  fire('view', payload);
}

export default { fireLinkTag, fireViewTag };
